enum Topic {
    Analytics = 'analytics',
}

export default Topic;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/tracking/Topic.ts